module.exports = __webpack_public_path__ + "img/counseling-phone.3ef1da8c.png";